// Ten obiekt będzie przechowywał zdarzenie gotowości do instalacji
let deferredPrompt = null;

/**
 * Nasłuchuj zdarzenia 'beforeinstallprompt', które przeglądarka wysyła,
 * gdy aplikacja PWA jest gotowa do instalacji.
 */
window.addEventListener('beforeinstallprompt', (e) => {
  // Zapobiegaj automatycznemu wyświetleniu mini-paska informacyjnego
  e.preventDefault();
  // Zapisz zdarzenie, aby móc je wywołać później
  deferredPrompt = e;
  // Wyślij niestandardowe zdarzenie, aby komponenty React mogły na nie zareagować
  window.dispatchEvent(new CustomEvent('pwa-installable', { detail: true }));
  console.log('PWA: Gotowość do instalacji zgłoszona.');
});

/**
 * Nasłuchuj zdarzenia 'appinstalled', aby wiedzieć, kiedy ukryć przycisk instalacji.
 */
window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  window.dispatchEvent(new CustomEvent('pwa-installable', { detail: false }));
  console.log('PWA: Aplikacja została zainstalowana.');
});

/**
 * Sprawdza, czy monit instalacji jest obecnie dostępny.
 * @returns {boolean}
 */
export const canInstallPWA = () => {
  return deferredPrompt !== null;
};

/**
 * Wywołuje systemowy monit instalacji PWA.
 * @returns {Promise<boolean>} - Zwraca true, jeśli użytkownik zaakceptował instalację.
 */
export const triggerPWAInstall = async () => {
  if (!deferredPrompt) {
    console.warn('PWA: Monit instalacji niedostępny.');
    alert('Aplikację można zainstalować tylko przez przeglądarkę Chrome lub Edge na komputerze lub Androidzie.');
    return false;
  }

  // Pokaż monit
  deferredPrompt.prompt();

  // Poczekaj na odpowiedź użytkownika
  const { outcome } = await deferredPrompt.userChoice;
  console.log(`PWA: Odpowiedź użytkownika: ${outcome}`);

  // Monit został użyty, więc go czyścimy
  deferredPrompt = null;

  // Zwróć informację, czy instalacja została zaakceptowana
  return outcome === 'accepted';
};